import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ReactGA from "react-ga";

ReactGA.initialize("GTM-5RK9R65");

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "800px",
    [theme.breakpoints.down("xs")]: {
      padding: "12px",
    },
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: "8px",
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: "24px",
  },
  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: "12px",
    marginTop: "15px",
  },
  tableWrapper: {
    marginBottom: "8px",
    borderRadius: "8px",
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
  },
  table: {
    minWidth: "500px",
  },
  tableHead: {
    backgroundColor: theme.palette.background.default,
  },
  headCell: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  bodyCell: {
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

function CopyrightInformation() {
  const classes = useStyles();

  useEffect(() => {
    ReactGA.event({
      category: "Copyright Information",
      action: "Viewing Copyright Information",
    });
    return () => { };
  }, []);

  return (
    <div className={classes.container}>
      <Typography variant="h3" className={classes.title}>
        Copyright
      </Typography>

      <Typography variant="subtitle1" className={classes.sectionTitle}>
        Web Application
      </Typography>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} aria-label="web application table">
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell className={classes.headCell}>
                Component Name
              </TableCell>
              <TableCell className={classes.headCell}>Copyright</TableCell>
              <TableCell align="right" className={classes.headCell}>
                License
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" className={classes.bodyCell}>
                smile-test-dashboard
              </TableCell>
              <TableCell className={classes.bodyCell}>
                Copyright (c) 2019 Devias
              </TableCell>
              <TableCell align="right" className={classes.bodyCell}>
                MIT
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>

      <Typography variant="subtitle1" className={classes.sectionTitle}>
        Mobile Application
      </Typography>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} aria-label="mobile application table">
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell className={classes.headCell}>
                Component Name
              </TableCell>
              <TableCell className={classes.headCell}>Copyright</TableCell>
              <TableCell align="right" className={classes.headCell}>
                License
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" className={classes.bodyCell}>
                conekta-react-native
              </TableCell>
              <TableCell className={classes.bodyCell}>
                Copyright (c) 2015 Dieam
              </TableCell>
              <TableCell align="right" className={classes.bodyCell}>
                MIT
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" className={classes.bodyCell}>
                jsreport-studio
              </TableCell>
              <TableCell className={classes.bodyCell}>
                Copyright (c) 2015 Erik Rasmussen
              </TableCell>
              <TableCell align="right" className={classes.bodyCell}>
                MIT
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" className={classes.bodyCell}>
                nest-url-mapper
              </TableCell>
              <TableCell className={classes.bodyCell}>
                Copyright (c) 2020 @ummo93
              </TableCell>
              <TableCell align="right" className={classes.bodyCell}>
                MIT
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" className={classes.bodyCell}>
                react-native-camera-library2
              </TableCell>
              <TableCell className={classes.bodyCell}>
                Copyright (c) 2015 Loch Wansbrough
              </TableCell>
              <TableCell align="right" className={classes.bodyCell}>
                MIT
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" className={classes.bodyCell}>
                react-native-lock
              </TableCell>
              <TableCell className={classes.bodyCell}>
                Copyright (c) 2015 Auth0, Inc.
              </TableCell>
              <TableCell align="right" className={classes.bodyCell}>
                MIT
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export default CopyrightInformation;
